import { createFileRoute } from '@tanstack/react-router';
import { PERMISSION_PARKING_TAG } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';

export const Route = createFileRoute('/_authenticated/system_settings/parking-tag/')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_PARKING_TAG, ['read'], '/unauthorized', context);

    return {
      ...context,
      documentTitle: {
        main: 'tab.parking-tag',
        suffix: 'table.systemSettings',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: ParkingTagRoute,
});

function ParkingTagRoute() {
  return null;
}
